// Version 1.6 2022-01-31

import {db} from "@/services/db";
import FirebaseVersion from "./firebaseVersion";
import firebase from 'firebase/app'
import 'firebase/firestore'
import TimeStamp from "@/services/timeStamp";
import {sortBewerbRundeTabTeams} from "@/services/data/meisterschaften/bewerbRundeTab";

export default class FirebaseWrite {

    static mergeFirebaseDocWithId(collectionName, documentId, dataObject){
        return new Promise( resolve => {
            db.collection(collectionName)
                .doc(documentId)
                .set(dataObject, {merge: true})
                .then(() =>{
                    dataObject.id = documentId;
                    resolve({successful: true, content: dataObject});
                })
                .catch(error => {
                    console.error ("error", error);
                    resolve({successful: false, content: error})
                });
        })
    }

    static add (collectionName, dataObject) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseWrite.add8(collectionName, dataObject);
        } else {
            //
        }
    }

        static add8(collectionName, dataObject){
            return new Promise( resolve => {
                db.collection(collectionName)
                    .add(dataObject)
                    .then(result =>{
                        dataObject.id = result.id;
                        resolve({successful: true, content: dataObject});
                    })
                    .catch(error => {
                        console.error ("error", error);
                        resolve({successful: false, content: error})
                    });
            })
        }

    static set (collectionName, documentId, dataObject) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseWrite.set8(collectionName, documentId, dataObject);
        } else {
            //
        }
    }

        static set8(collectionName, documentId, dataObject){
            return new Promise( resolve => {
                db.collection(collectionName)
                    .doc(documentId)
                    .set(dataObject)
                    .then(() =>{
                        dataObject.id = documentId;
                        resolve({successful: true, content: dataObject});
                    })
                    .catch(error => {
                        console.error ("error", error);
                        resolve({successful: false, content: error})
                    });
            })
        }

    static update (collectionName, documentId, dataObject) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseWrite.update8(collectionName, documentId, dataObject);
        } else {
            //
        }
    }
        static update8(collectionName, documentId, dataObject){
            Object.keys(dataObject).forEach( (key) => {
                if ( dataObject[key] === 'firebase.firestore.FieldValue.delete()' ) {
                    dataObject[key] = firebase.firestore.FieldValue.delete()
                } else if (dataObject[key] === 'firebase.firestore.FieldValue.increment(1)') {
                    dataObject[key] = firebase.firestore.FieldValue.increment(1)
                } else if (dataObject[key]?.action === 'arrayUnion' ) {
                    dataObject[key] = firebase.firestore.FieldValue.arrayUnion(dataObject[key].value)
                }
            });
            return new Promise( resolve => {
                db.collection(collectionName)
                    .doc(documentId)
                    .update(dataObject)
                    .then(() =>{
                        resolve({successful: true});
                    })
                    .catch(error => {
                        console.error ("error", error);
                        resolve({successful: false, content: error})
                    });
            })
        }

    static delete (collectionName, documentId) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseWrite.delete8(collectionName, documentId);
        } else {
            //
        }
    }
        static delete8 (collectionName, documentId) {
            return new Promise( resolve => {
                db.collection(collectionName)
                    .doc(documentId).delete()
                .then(() => {
                    console.log("Document successfully deleted!");
                    resolve({successful: true});
                }).catch((error) => {
                    console.error("Error removing document: ", error);
                    resolve({successful: false, content: error})
                });
            })
        }

    static batch(batchList){
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseWrite.batch8(batchList);
        } else {
            //
        }
    }
        static batch8 (batchList){
            let batch = db.batch();
            batchList.forEach( (batchItem) => {
                const doc = db.collection(batchItem.collection)
                                .doc(batchItem.documentId);
                switch (batchItem.action) {
                    case 'set':
                        batch.set(doc, batchItem.data);
                        break;
                    case 'update':
                        batch.update(doc, batchItem.data);
                        break;
                    case 'delete':
                        batch.delete(doc);
                        break;
                }
            });
            return new Promise( resolve => {
                batch.commit()
                    .then(() => {
                        console.log("Batch successfully processed!");
                        resolve({successful: true});
                    })
                    .catch((error) => {
                        console.error("Error processing batch: ", error);
                        resolve({successful: false, content: error})
                    });
            })
        }

// app specific writes
    static updateTeamInRunde (documentId, team, rundeId){
        let sfDocRef = db.collection('meisterschaftenBewerbe').doc(documentId);
        return new Promise( resolve => {
            db.runTransaction((transaction) => {
                return transaction.get(sfDocRef).then((sfDoc) => {
                    if (!sfDoc.exists) throw "Bei der Suche ist ein Fehler aufgetreten"
                    const teams = Object.values(sfDoc.data().runden[rundeId].teams).filter(
                        (existingTeam) => existingTeam.id !== team.id
                    ).map(
                        (team) => team.settings.name + team.settings.landesverband + team.settings.vereinsName
                    )
                    if ( teams.includes(team.settings.name + team.settings.landesverband + team.settings.vereinsName) ) {
                        throw "Diese Person oder dieses Team exisitiert bereits!";
                    }
                    let id = team.id;
                    if ( !team.id ) {
                        id = 0
                        let runde = sfDoc.data().runden[rundeId]
                        do { id = TimeStamp.getGMTTimestamp() } while ( runde.teams[id] );
                        team.id = id;
                    }
                    transaction.update(sfDocRef, {
                        ['runden.' + rundeId + '.teams.' + id]: team
                    });
                    return id
                });
            })
            .then((id) => {
                console.log("Transaction write successful!");
                resolve({successful: true, content: {id: id}});
            }).catch((error) => {
                console.error("Transaction write error: ", error);
                resolve({successful: false, content: error})
            });
        })
    }

    static updateTeamResultsInRunde (documentId, team, rundeId){
        let sfDocRef = db.collection('meisterschaftenBewerbe').doc(documentId);
        return new Promise( resolve => {
            db.runTransaction((transaction) => {
                return transaction.get(sfDocRef).then((sfDoc) => {
                    if (!sfDoc.exists) throw "Bei der Suche ist ein Fehler aufgetreten"
                    const teamsMap = sfDoc.data().runden[rundeId].teams;
                    teamsMap[team.id].results = team.results;
                    const teams = sortBewerbRundeTabTeams(teamsMap, true)
                    transaction.update(sfDocRef, {
                        ['runden.' + rundeId + '.teams']: teams
                    });
                    return teams
                });
            })
            .then((teams) => {
                console.log("Transaction write successful!");
                resolve({successful: true, content: {teams: teams}});
            }).catch((error) => {
                console.error("Transaction write error: ", error);
                resolve({successful: false, content: error})
            });
        })
    }

    static deleteTeamFromRunde (documentId, teamId, rundeId){
        let sfDocRef = db.collection('meisterschaftenBewerbe').doc(documentId);
        return new Promise( resolve => {
            db.runTransaction((transaction) => {
                return transaction.get(sfDocRef).then((sfDoc) => {
                    if (!sfDoc.exists) throw "Bei der Suche ist ein Fehler aufgetreten"
                    const teamsMap = sfDoc.data().runden[rundeId].teams;
                    delete teamsMap[teamId];
                    const teams = sortBewerbRundeTabTeams(teamsMap, true)
                    transaction.update(sfDocRef, {
                        ['runden.' + rundeId + '.teams']: teams
                    });
                    return teams
                });
            })
                .then((teams) => {
                    console.log("Transaction write successful!");
                    resolve({successful: true, content: {teams: teams}});
                }).catch((error) => {
                console.error("Transaction write error: ", error);
                resolve({successful: false, content: error})
            });
        })
    }
}